import React from 'react'
import StorageContent from '../components/storage/StorageContent'

const AppsStorage = () => {
  return (
    <>
    
      <StorageContent />
    </>
  )
}

export default AppsStorage